import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { PRICING_PLANS, TAX_RATES } from 'constants/apis';
import axios from 'helpers/axios';

// 1 hour.
const STALE_TIME = 60 * 60 * 1000;

/**
 * Fetch all active pricing plans from the Global API
 * @returns {Object} Active prices
 */
const fetchActivePricingPlans = async () => {
  const { data: prices } = await axios.get(PRICING_PLANS, {
    params: {
      active: true,
    },
  });

  return prices;
};

/**
 * Fetch all active tax rates from the Global API
 * @returns {Object[]} Active tax rates
 */
const fetchTaxRates = async () => {
  const { data: taxRates } = await axios.get(TAX_RATES, {
    params: {
      active: true,
    },
  });

  return taxRates;
};

/**
 * Fetch active plans and tax rates
 *
 * @returns {Object} Async result containing activePlans and taxRates
 */
const useFetchPlans = () => {
  const activePricingPlansQuery = useQuery(['activePricingPlans'], fetchActivePricingPlans, {
    staleTime: STALE_TIME,
  });
  const taxRatesQuery = useQuery(['taxRates'], fetchTaxRates, { staleTime: STALE_TIME });

  return useMemo(
    () => ({
      activePricingPlans: activePricingPlansQuery.data ?? [],
      taxRates: taxRatesQuery.data ?? [],
    }),
    [activePricingPlansQuery.data, taxRatesQuery.data]
  );
};

export default useFetchPlans;
